import { render, staticRenderFns } from "./item copy.vue?vue&type=template&id=790f351f&scoped=true&"
import script from "./item copy.vue?vue&type=script&lang=js&"
export * from "./item copy.vue?vue&type=script&lang=js&"
import style0 from "./item copy.vue?vue&type=style&index=0&id=790f351f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790f351f",
  null
  
)

export default component.exports